import React from "react";
import { Trans } from "react-i18next";
import { AboutDialogProps, AboutDialogState } from "./interface";
import { isElectron } from "react-device-detect";
import { openExternalUrl } from "../../../utils/serviceUtils/urlUtil";

class AboutDialog extends React.Component<AboutDialogProps, AboutDialogState> {
  constructor(props: AboutDialogProps) {
    super(props);
    this.state = {};
  }
  handleJump = (url: string) => {
    openExternalUrl(url);
    this.props.handleAbout(false);
  };

  render() {
    return (
      <div
        className="sort-dialog-container"
        onMouseLeave={() => {
          this.props.handleAbout(false);
        }}
        onMouseEnter={() => {
          this.props.handleAbout(true);
        }}
        style={
          this.props.isNewWarning
            ? { left: "510px", width: "150px" }
            : {
                left: "510px",

                width: "150px",
              }
        }
      >
        <ul className="sort-by-category">
          <li
            className="sort-by-category-list"
            onClick={() => {
              this.props.handleSetting(true);
              this.props.handleAbout(false);
            }}
          >
            <Trans>Setting</Trans>
          </li>
          <li
            className="sort-by-category-list"
            onClick={() => {
              this.handleJump("https://www.yeyulingfeng.com/");
            }}
          >
            <Trans>Our Website</Trans>
          </li>
          <li
            className="sort-by-category-list"
            onClick={() => {
              this.handleJump("https://github.com/troyeguo/koodo-reader");
            }}
          >
            <Trans>Github Repo</Trans>
          </li>
        </ul>
      </div>
    );
  }
}

export default AboutDialog;
